<vtr-page-layout [title]="setTitle()"
	[textId]="'hwscan'"
	[pageCssClass]="'hardware-scan'"
	[shiftLeftUp]="true"
	[shiftRightUp]="true"
	[hideBack]="!isScanDoneExecuting() && (isScanExecuting() || isRecoverExecuting())"
	[back]="'common.ui.back' | translate"
	[backId]="'hwscan-back-btn'"
	[isInnerBack]="isScanDoneExecuting()"
	(innerBack)="redirectBack()">

	<left-content>
		<div class="vtr-device-information">
			<div class="container-fluid">
				<router-outlet></router-outlet>
			</div>
		</div>
	</left-content>

	<right-content>
		<div class="container-fluid">
			<!-- Schedule Scan feature will be implemented and fixed on Release 3.2 -->
			<!-- <div class="row">
						<div class="col col-12 cont mb-40" *ngIf="((isLoadingDone() || isScanDoneExecuting()) && !isRecoverExecuting()) && !getIsViewingRecoverLog()">
							<vtr-widget-schedule-scan>
							</vtr-widget-schedule-scan>
						</div>
					</div> -->

			<!-- Snapshot Widget -->
			<div class="row" *ngIf="isSnapshotEnabledOnHypothesis">
				<div class="col col-12 mb-40">
					<vtr-widget-snapshot [itemParent]="'HardwareScan'">
					</vtr-widget-snapshot>
				</div>
			</div>

			<!-- Recover Bad Sectores will be integrated in a future release -->
			<div class="row" *ngIf="!isRecoverExecuting()">
				<div class="col col-12 cont mb-40">
					<vtr-widget-recover-bad-sectors
						[widgetId]="'hwscan-rbs-widget'"
						[title]="'hardwareScan.recoverBadSectors.title' | translate"
						[description]="'hardwareScan.recoverBadSectors.description' | translate"
						[disable]="!hasDevicesToRecoverBadSectors() || isRecoverDisabled()"
						[tooltipText]="('hardwareScan.recoverBadSectors.title' | translate)">
					</vtr-widget-recover-bad-sectors>
				</div>
			</div>

			<div class="row" *ngIf="shouldShowPreviousResultsWidget()">
				<div class="col col-12 mb-40">
					<vtr-widget-hardware-scan-status
						[widgetId]="'hwscan-previous-results-widget'">
					</vtr-widget-hardware-scan-status>
				</div>
			</div>

			<div class="row" *ngIf="showDownloadToolCard">
				<div class="col col-12 mb-40">
					<vtr-widget-hardware-scan-support-card
						[widgetId]="'hwscan-support-card'">
					</vtr-widget-hardware-scan-support-card>
				</div>
			</div>
		</div>
	</right-content>

</vtr-page-layout>

